import { Fragment, useEffect, useState, useMemo } from "react";
import FsLightbox from 'fslightbox-react';
import icon1 from '../../../assets/images/icons/01.png'
import icon2 from '../../../assets/images/icons/02.png'
import icon3 from '../../../assets/images/icons/03.png'
import icon4 from '../../../assets/images/icons/04.png'
import icon8 from '../../../assets/images/icons/08.png'
import icon6 from '../../../assets/images/icons/06.png'
import icon7 from '../../../assets/images/icons/07.png'

import icon5 from '../../../assets/images/icons/05.png'
import shap2 from '../../../assets/images/shapes/02.png'
import shap4 from '../../../assets/images/shapes/04.png'
import shap6 from '../../../assets/images/shapes/06.png'
import { Accordion, Badge, Button, Card, Col, Form, ProgressBar, Row, Spinner, Tab } from "react-bootstrap";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import { DEV_SERVER } from "../../../constants/urls";
import { userSignal } from "../../../signal/userSignal";
import { toast } from "react-toastify";
import { organisationSignal } from "../../../signal/organisationSignal";
import { confirmAlert } from "react-confirm-alert";
import { allUsersSignal } from "../../../signal/allUsersSignal";
import { Link, useNavigate } from "react-router-dom";
import { stateNameFormatter } from "../../../utilities/stateNameFormatter";
import Avatar from "react-avatar";
import Select from "react-select";
import { stateNames } from "../../../utilities/stateNames";
import { GetCompanyList } from "../tally/services/companyList";
import ReactChipInput from "react-chip-input";
import CSVReader from "react-csv-reader";
import * as moment from "moment";

const colorOptionsForOrderStatuses = [
    "orange",
    "blue",
    "green",
    "red",
    "violet",
    "gray",
    "black"
]

const colorHexMapping = {
    "red": "#c03221",
    "violet": "#001F4D",
    "green": "#1aa053",
    "orange": "#f16a1b",
    "blue": "#3a57e8",
    "gray": "#dee2e6",
    "black": "#212529"
}

const colorHexMappingReverse = {
    "#c03221": "red",
    "#001F4D": "violet",
    "#1aa053": "green",
    "#f16a1b": "orange",
    "#3a57e8": "blue",
    "#dee2e6": "gray",
    "#212529": "black"
}


export default function OrgSettings() {

    const [toggler, setToggler] = useState();
    const [activeKey, setActiveKey] = useState(0);

    const [logo, setLogo] = useState(organisationSignal.value?.logo ? organisationSignal.value?.logo : "")
    const [name, setName] = useState(organisationSignal.value?.name ? organisationSignal.value?.name : "")
    const [email, setEmail] = useState(organisationSignal.value?.email ? organisationSignal.value?.email : "")
    const [website, setWebsite] = useState(organisationSignal.value?.website ? organisationSignal.value?.website : "")
    const [gstin, setGstin] = useState(organisationSignal.value?.gstin ? organisationSignal.value?.gstin : "")
    const [address, setAddress] = useState(organisationSignal.value?.address ? organisationSignal.value?.address : "")
    const [state, setState] = useState(organisationSignal.value?.state ? organisationSignal.value?.state : "")
    const [tripRules, setTripRules] = useState(organisationSignal.value?.tripRules ? organisationSignal.value?.tripRules : [])
    const [fixedExpenses, setFixedExpenses] = useState(organisationSignal.value?.fixedExpenses ? organisationSignal.value?.fixedExpenses : [])
    const [expenseTypes, setExpenseTypes] = useState(organisationSignal.value?.expenseTypes ? organisationSignal.value?.expenseTypes : [])
    const [modeOfTransports, setModeOfTransports] = useState(organisationSignal.value?.modeOfTransports ? organisationSignal.value?.modeOfTransports : [])
    const [dailyAllowanceRules, setDailyAllowanceRules] = useState(organisationSignal.value?.dailyAllowanceRules ? organisationSignal.value?.dailyAllowanceRules : [])
    const [isStartImageRequired, setIsStartImageRequired] = useState(organisationSignal.value?.isStartImageRequired ? organisationSignal.value?.isStartImageRequired : false)
    const [isOrderModuleActivated, setIsOrderModuleActivated] = useState(organisationSignal.value?.isOrderModuleActivated ? organisationSignal.value?.isOrderModuleActivated : false)
    const [isTallyIntegrationActivated, setIsTallyIntegrationActivated] = useState(organisationSignal.value?.isTallyIntegrationActivated ? organisationSignal.value?.isTallyIntegrationActivated : false)
    const [tallyConfig, setTallyConfig] = useState(organisationSignal.value?.tallyConfig ? organisationSignal.value?.tallyConfig : {})
    const [orderStageTypes, setOrderStageTypes] = useState(organisationSignal.value?.orderStageTypes ? organisationSignal.value?.orderStageTypes : [])
    const [orderStageColors, setOrderStageColors] = useState(organisationSignal.value?.orderStageColors ? organisationSignal.value?.orderStageColors : {})
    const [compensationPerKm, setCompensationPerKm] = useState(organisationSignal.value?.compensationPerKm ? organisationSignal.value?.compensationPerKm : 0.0)
    const [autoTripStartEnabled, setAutoTripStartEnabled] = useState(organisationSignal.value?.autoTripStartEnabled ? organisationSignal.value?.autoTripStartEnabled : false)
    const [autoTripStartTime, setAutoTripStartTime] = useState(organisationSignal.value?.autoTripStartTime ? organisationSignal.value?.autoTripStartTime : "00:00")
    const [autoTripEndTime, setAutoTripEndTime] = useState(organisationSignal.value?.autoTripEndTime ? organisationSignal.value?.autoTripEndTime : "00:00")
    const [autoTripStartForEmployees, setAutoTripStartForEmployees] = useState(organisationSignal.value?.autoTripStartForEmployees ? organisationSignal.value?.autoTripStartForEmployees : false)
    const [autoTripStartForManagers, setAutoTripStartForManagers] = useState(organisationSignal.value?.autoTripStartForManagers ? organisationSignal.value?.autoTripStartForManagers : false)
    const [autoTripStartForSuperAdmins, setAutoTripStartForSuperAdmins] = useState(organisationSignal.value?.autoTripStartForSuperAdmins ? organisationSignal.value?.autoTripStartForSuperAdmins : false)
    const [maxTripsPerDay, setMaxTripsPerDay] = useState(organisationSignal.value?.maxTripsPerDay ? organisationSignal.value?.maxTripsPerDay : 10)
    const [isSaturdayWorking, setIsSaturdayWorking] = useState(organisationSignal.value?.isSaturdayWorking ? organisationSignal.value?.isSaturdayWorking : false)
    const [isSundayWorking, setIsSundayWorking] = useState(organisationSignal.value?.isSundayWorking ? organisationSignal.value?.isSundayWorking : false)
    const [holidays, setHolidays] = useState(organisationSignal.value?.holidays !== undefined ? organisationSignal.value?.holidays : {})
    const [categories, setCategories] = useState([])
    const [packagingTypes, setPackagingTypes] = useState([])
    const [fileLoadingStatus, setFileLoadingStatus] = useState(null)

    // Leave allocation & reset state
    const [leaveResetCount, setLeaveResetCount] = useState(20)
    const [selectedLeaveState, setSelectedLeaveState] = useState({ value: "ALL", label: "All States" })
    const [isResettingLeaves, setIsResettingLeaves] = useState(false)
    const [resetProgress, setResetProgress] = useState({ current: 0, total: 0 })
    const [employeesList, setEmployeesList] = useState([])
    const [loadingEmployees, setLoadingEmployees] = useState(false)

    const navigate = useNavigate()

    useEffect(() => {

        if (!userSignal.value?.user?.isAdmin) {
            navigate('/dashboard')
        }

        setTimeout(() => {
            if (organisationSignal.value === null) {
                getOrganisation.refetch({ cancelRefetch: true })
            } else {
                setName(organisationSignal.value?.name ? organisationSignal.value?.name : "")
                setAddress(organisationSignal.value?.address ? organisationSignal.value?.address : "")
                setState(organisationSignal.value?.state ? organisationSignal.value?.state : "")
                setEmail(organisationSignal.value?.email ? organisationSignal.value?.email : "")
                setLogo(organisationSignal.value?.logo ? organisationSignal.value?.logo : "")
                setWebsite(organisationSignal.value?.website ? organisationSignal.value?.website : "")
                setGstin(organisationSignal.value?.gstin ? organisationSignal.value?.gstin : "")
                setTripRules(organisationSignal.value?.tripRules ? organisationSignal.value?.tripRules : [])
                setFixedExpenses(organisationSignal.value?.fixedExpenses ? organisationSignal.value?.fixedExpenses : [])
                setExpenseTypes(organisationSignal.value?.expenseTypes ? organisationSignal.value?.expenseTypes : [])
                setModeOfTransports(organisationSignal.value?.modeOfTransports ? organisationSignal.value?.modeOfTransports : [])
                setDailyAllowanceRules(organisationSignal.value?.dailyAllowanceRules ? organisationSignal.value?.dailyAllowanceRules : [])
                setIsStartImageRequired(organisationSignal.value?.isStartImageRequired ? organisationSignal.value?.isStartImageRequired : false)
                setIsOrderModuleActivated(organisationSignal.value?.isOrderModuleActivated ? organisationSignal.value?.isOrderModuleActivated : false)
                setIsTallyIntegrationActivated(organisationSignal.value?.isTallyIntegrationActivated ? organisationSignal.value?.isTallyIntegrationActivated : false)
                setTallyConfig(organisationSignal.value?.tallyConfig ? organisationSignal.value?.tallyConfig : {})
                setOrderStageTypes(organisationSignal.value?.orderStageTypes ? organisationSignal.value?.orderStageTypes : [])
                setOrderStageColors(organisationSignal.value?.orderStageColors ? organisationSignal.value?.orderStageColors : {})
                setCompensationPerKm(organisationSignal.value?.compensationPerKm ? organisationSignal.value?.compensationPerKm : 0.0)
                setMaxTripsPerDay(organisationSignal.value?.maxTripsPerDay ? organisationSignal.value?.maxTripsPerDay : 10)
                setAutoTripStartEnabled(organisationSignal.value?.autoTripStartEnabled ? organisationSignal.value?.autoTripStartEnabled : false)
                setAutoTripStartTime(organisationSignal.value?.autoTripStartTime ? organisationSignal.value?.autoTripStartTime : "00:00")
                setAutoTripEndTime(organisationSignal.value?.autoTripEndTime ? organisationSignal.value?.autoTripEndTime : "00:00")
                setAutoTripStartForEmployees(organisationSignal.value?.autoTripStartForEmployees ? organisationSignal.value?.autoTripStartForEmployees : false)
                setAutoTripStartForManagers(organisationSignal.value?.autoTripStartForManagers ? organisationSignal.value?.autoTripStartForManagers : false)
                setAutoTripStartForSuperAdmins(organisationSignal.value?.autoTripStartForSuperAdmins ? organisationSignal.value?.autoTripStartForSuperAdmins : false)
                setIsSaturdayWorking(organisationSignal.value?.isSaturdayWorking ? organisationSignal.value?.isSaturdayWorking : false)
                setIsSundayWorking(organisationSignal.value?.isSundayWorking ? organisationSignal.value?.isSundayWorking : false)
                setHolidays(organisationSignal.value?.holidays !== undefined ? organisationSignal.value?.holidays : {})
                setCategories(organisationSignal.value?.categories ? organisationSignal.value?.categories : [])
                setPackagingTypes(organisationSignal.value?.packagingTypes ? organisationSignal.value?.packagingTypes : [])

                if (Object.keys(organisationSignal.value?.holidays !== undefined && organisationSignal.value?.holidays).length > 0) {
                    setFileLoadingStatus(false)
                }
            }
        }, 500)

    }, [])

    useEffect(() => {
        // get the href attribute
        const href = window.location.href?.split("#")[1]
        if (href) {
            setActiveKey(href)
        } else {
            setActiveKey(0)
        }
    }, [window.location.href])

    const getOrganisation = useQuery("organisation", async () => {
        let resp = await axios.get(`${DEV_SERVER}/auth/v2/organisation/`, {
            headers: {
                "Authorization": `Bearer ${userSignal.value?.token}`
            }
        })
        return resp.data
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                organisationSignal.value = data.data
                setName(data.data.name ? data.data.name : "")
                setAddress(data.data.address ? data.data.address : "")
                setState(data.data.state ? data.data.state : "")
                setEmail(data.data.email ? data.data.email : "")
                setLogo(data.data.logo ? data.data.logo : "")
                setWebsite(data.data.website ? data.data.website : "")
                setGstin(data.data.gstin ? data.data.gstin : "")
                setTripRules(data.data.tripRules ? data.data.tripRules : [])
                setFixedExpenses(data.data.fixedExpenses ? data.data.fixedExpenses : [])
                setExpenseTypes(data.data.expenseTypes ? data.data.expenseTypes : [])
                setModeOfTransports(data.data.modeOfTransports ? data.data.modeOfTransports : [])
                setDailyAllowanceRules(data.data.dailyAllowanceRules ? data.data.dailyAllowanceRules : [])
                setIsStartImageRequired(data.data.isStartImageRequired ? data.data.isStartImageRequired : false)
                setIsOrderModuleActivated(data.data.isOrderModuleActivated ? data.data.isOrderModuleActivated : false)
                setIsTallyIntegrationActivated(data.data.isTallyIntegrationActivated ? data.data.isTallyIntegrationActivated : false)
                setTallyConfig(data.data.tallyConfig ? data.data.tallyConfig : {})
                setOrderStageTypes(data.data.orderStageTypes ? data.data.orderStageTypes : [])
                setOrderStageColors(data.data.orderStageColors ? data.data.orderStageColors : {})
                setCompensationPerKm(data.data.compensationPerKm ? data.data.compensationPerKm : 0.0)
                setMaxTripsPerDay(data.data.maxTripsPerDay ? data.data.maxTripsPerDay : 10)
                setAutoTripStartEnabled(data.data?.autoTripStartEnabled ? data.data?.autoTripStartEnabled : false)
                setAutoTripStartTime(data.data?.autoTripStartTime ? data.data?.autoTripStartTime : "00:00")
                setAutoTripEndTime(data.data?.autoTripEndTime ? data.data?.autoTripEndTime : "00:00")
                setAutoTripStartForEmployees(data.data?.autoTripStartForEmployees ? data.data?.autoTripStartForEmployees : false)
                setAutoTripStartForManagers(data.data?.autoTripStartForManagers ? data.data?.autoTripStartForManagers : false)
                setAutoTripStartForSuperAdmins(data.data?.autoTripStartForSuperAdmins ? data.data?.autoTripStartForSuperAdmins : false)
                setIsSaturdayWorking(data.data.isSaturdayWorking ? data.data.isSaturdayWorking : false)
                setIsSundayWorking(data.data.isSundayWorking ? data.data.isSundayWorking : false)
                setHolidays(data.data.holidays !== undefined ? data.data.holidays : {})
                setCategories(data.data.categories ? data.data.categories : [])
                setPackagingTypes(data.data.packagingTypes ? data.data.packagingTypes : [])
            } else {
                toast.error(data.message)
            }
        }
    })

    const imageUploadMutation = useMutation((data) => axios.post(`${DEV_SERVER}/auth/v2/uploadMedia`, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
            "Authorization": `Bearer ${userSignal.value?.token}`
        }
    }), {
        onSuccess: (data) => {
            if (data?.data?.status) {
                if (data?.data?.data?.length > 0) {
                    setLogo(data?.data?.data[0]?.url)
                } else {
                    toast.error("Something went wrong")
                }
            } else {
                toast.error(data.data.message)
            }
        },
        onError: (error) => {
            console.log("error ", error)
            if (error.response?.data?.message) {
                toast.error(error.response.data.message)
            } else {
                toast.error(error.message)
            }
        }
    })

    const updateOrgMutation = useMutation((data) => axios.put(`${DEV_SERVER}/auth/v2/organisation`, data, {
        headers: {
            "Authorization": `Bearer ${userSignal.value?.token}`
        }
    }), {
        onSuccess: (data) => {
            if (data.data.status) {
                toast.success(data.data.message)
                organisationSignal.value = data?.data?.data
            } else {
                toast.error(data.data.message)
            }
        },
        onError: (error) => {
            console.log("error ", error)
            if (error.response?.data?.message) {
                toast.error(error.response.data.message)
            } else {
                toast.error(error.message)
            }
        }
    })

    const getCompaniesFromTally = useMutation((data) => {
        let resp = GetCompanyList(`http://${data.host}`, data?.port)
        return resp
    }, {
        onSuccess: (data) => {
            if (data) {
                let temp = { ...tallyConfig }
                let tempCompanies = []
                if (temp.companies) {
                    tempCompanies = [...temp.companies]
                }
                if (Object.keys(data).length > 0) {
                    Object.keys(data).map((key) => {
                        let company = data[key]
                        console.log("company ", company)
                        tempCompanies.push({ companyName: company?.name, syncFromDate: moment(company?.startingFrom).format("YYYY-MM-DD") })
                    })
                }
                temp.companies = tempCompanies
                setTallyConfig(temp)
            } else {
                toast.error("Unable to connect to Tally")
            }
        },
        onError: (error) => {
            console.log("error ", error)
            toast.error("Unable to connect to Tally")
        }
    })

    const tallySyncMasterCreateMutation = useMutation(() => axios.post(`${DEV_SERVER}/auth/v2/employee/createTallySyncMaster`, {}, {
        headers: {
            "Authorization": `Bearer ${userSignal.value?.token}`
        }
    }), {
        onSuccess: (data) => {
            if (data.data.status) {
                toast.success(data.data.message)
            } else {
                toast.error(data.data.message)
            }
        },

        onError: (error) => {
            console.log("error ", error)
            if (error.response?.data?.message) {
                toast.error(error.response.data.message)
            } else {
                toast.error(error.message)
            }
        }
    })

    const handleFileUpload = (e) => {
        // e.preventDefault()
        let formData = new FormData()
        formData.append("media", e.target.files[0])
        imageUploadMutation.mutate(formData)
    }

    const handleSubmit = async () => {
        if (name === "") {
            toast.error("Name is required");
            return;
        }

        if (address === "") {
            toast.error("Address is required");
            return;
        }

        let flag = true

        if (isOrderModuleActivated && orderStageTypes?.length > 0) {
            await new Promise((resolve, reject) => {
                orderStageTypes.map((stage, index) => {
                    if (stage === "") {
                        toast.error(`Stage ${index + 1} name is required`);
                        reject()
                    }

                    if (orderStageColors[stage] === "") {
                        toast.error(`Stage ${index + 1} color is required`);
                        reject()
                    }
                })
                resolve()
            }).catch(err => {
                flag = false
            })
        }

        if (tripRules?.length || fixedExpenses?.length || modeOfTransports?.length || dailyAllowanceRules?.length) {
            if (tripRules?.length !== 0) {

                await new Promise((resolve, reject) => {
                    tripRules.map((rule, index) => {

                        if (rule?.name === "") {
                            toast.error(`Rule ${index + 1} name is required`);
                            reject()
                        }

                        if (rule?.conditions?.length === 0) {
                            toast.error(`Rule ${index + 1} must have at least one condition`);
                            reject()
                        }

                        if (rule?.conditions?.length) {
                            rule?.conditions?.map((condition, index2) => {
                                if (condition.field === "") {
                                    toast.error(`Rule ${index + 1} condition ${index2 + 1} field is required`);
                                    reject()
                                }

                                if (condition.operator === "") {
                                    toast.error(`Rule ${index + 1} condition ${index2 + 1} operator is required`);
                                    reject()
                                }

                                if (condition.value === "") {
                                    toast.error(`Rule ${index + 1} condition ${index2 + 1} value is required`);
                                    reject()
                                }
                            })
                        }
                    })
                    resolve()
                }).catch(err => {
                    flag = false;
                })
            }

            if (fixedExpenses?.length) {
                await new Promise((resolve, reject) => {
                    fixedExpenses?.map(async (expense, index) => {
                        if (expense?.name === "") {
                            toast.error(`Expense ${index + 1} name is required`);
                            reject();
                        }

                        if (expense?.amount === "") {
                            toast.error(`Expense ${index + 1} amount is required`);
                            reject();
                        }
                    })
                    resolve()
                }).catch(err => {
                    flag = false
                })
            }

            if(expenseTypes?.length) {
                await new Promise((resolve, reject) => {
                    expenseTypes?.map(async (expense, index) => {
                        if (expense?.name === "") {
                            toast.error(`Expense Type ${index + 1} name is required`);
                            reject();
                        }
                    })
                    resolve()
                }).catch(err => {
                    flag = false
                })
            }

            if (modeOfTransports?.length) {
                await new Promise((resolve, reject) => {
                    modeOfTransports?.map(async (transport, index) => {
                        if (transport?.name === "") {
                            toast.error(`Transport ${index + 1} name is required`);
                            reject();
                        }

                        if (transport?.amount === "") {
                            toast.error(`Transport ${index + 1} amount is required`);
                            reject();
                        }
                    })
                    resolve()
                }).catch(err => {
                    flag = false
                })
            }

            if (dailyAllowanceRules?.length) {
                await new Promise((resolve, reject) => {
                    dailyAllowanceRules?.map(async (rule, index) => {
                        if (rule?.name === "") {
                            toast.error(`Daily Allowance Rule ${index + 1} name is required`);
                            reject();
                        }

                        if (rule?.amount === "") {
                            toast.error(`Daily Allowance Rule ${index + 1} amount is required`);
                            reject();
                        }
                    })
                    resolve()
                }).catch(err => {
                    flag = false
                })
            }
        }

        if (!flag) {
            return
        }

        // let startImageRequired false

        // if (typeof(isStartImageRequired) === "string") {
        //     setIsStartImageRequired(isStartImageRequired === "true" ? true : false)
        // }

        let _state = stateNameFormatter(state)

        let body = {
            name,
            address,
            state: _state,
            email,
            logo,
            website,
            gstin,
            tripRules,
            fixedExpenses,
            expenseTypes,
            modeOfTransports,
            dailyAllowanceRules,
            isStartImageRequired,
            isOrderModuleActivated,
            isTallyIntegrationActivated,
            tallyConfig,
            orderStageTypes,
            orderStageColors,
            compensationPerKm,
            maxTripsPerDay,
            autoTripStartEnabled,
            isSaturdayWorking,
            isSundayWorking,
            holidays,
            categories,
            packagingTypes
        }

        if (autoTripStartEnabled) {
            body.autoTripStartTime = autoTripStartTime
            body.autoTripEndTime = autoTripEndTime
            body.autoTripStartForEmployees = autoTripStartForEmployees
            body.autoTripStartForManagers = autoTripStartForManagers
            body.autoTripStartForSuperAdmins = autoTripStartForSuperAdmins
        }

        updateOrgMutation.mutate(body);
    };

    const handleForce = (data, fileInfo) => {
        setFileLoadingStatus(true)
        let temp = {}
        for (let i = 0; i < data.length; i++) {
            let dt = data[i]
            if (dt?.holiday === undefined) {
                toast.error("CSV file must have a column with name 'holiday'")
                setFileLoadingStatus(false)
                return
            }
            temp[`${dt?.holiday?.toString()}`] = dt?.event
        }
        setHolidays(temp)
        setFileLoadingStatus(false)
    };

    const papaparseOptions = {
        header: true,
        dynamicTyping: true,
        skipEmptyLines: true,
        transformHeader: header => header.toLowerCase().replace(/\W/g, "_")
    };

    const fetchEmployees = async () => {
        try {
            setLoadingEmployees(true)
            const resp = await axios.get(`${DEV_SERVER}/auth/v2/employee/getEmployees`, {
                headers: {
                    Authorization: `Bearer ${userSignal.value?.token}`,
                },
            })
            if (resp.data?.status && Array.isArray(resp.data?.data)) {
                setEmployeesList(resp.data.data)
                let temp = {}
                resp.data.data.forEach(item => {
                    temp[item.id] = item
                })
                allUsersSignal.value = temp
            }
        } catch (err) {
            console.error("Failed to fetch employees", err)
            toast.error("Failed to fetch employees list")
        } finally {
            setLoadingEmployees(false)
        }
    }

    useEffect(() => {
        if (activeKey === "holidayAndLeaveConfiguration") {
            if (allUsersSignal?.value && Object.keys(allUsersSignal.value).length > 0) {
                setEmployeesList(Object.values(allUsersSignal.value))
            }
            fetchEmployees()
        }
    }, [activeKey])

    const leaveStateOptions = useMemo(() => {
        const stateCountMap = {}
        let unassigned = 0
        let totalCount = 0

        employeesList.forEach((emp) => {
            if (emp?.isTallySyncMaster) return
            totalCount++
            const s = emp?.state ? emp.state.trim() : ""
            if (s) {
                stateCountMap[s] = (stateCountMap[s] || 0) + 1
            } else {
                unassigned++
            }
        })

        const activeStates = Object.keys(stateCountMap).sort((a, b) => a.localeCompare(b))
        const options = [
            { value: "ALL", label: `All States (${totalCount} employees)` }
        ]

        if (unassigned > 0) {
            options.push({ value: "UNASSIGNED", label: `Unassigned / No State (${unassigned} employees)` })
        }

        activeStates.forEach((st) => {
            options.push({
                value: st,
                label: `${st} (${stateCountMap[st]} ${stateCountMap[st] === 1 ? 'employee' : 'employees'})`
            })
        })

        stateNames.forEach((st) => {
            const alreadyAdded = activeStates.some(s => s.toLowerCase() === st.toLowerCase())
            if (!alreadyAdded) {
                options.push({
                    value: st,
                    label: `${st} (0 employees)`
                })
            }
        })

        return options
    }, [employeesList])

    const targetedEmployees = useMemo(() => {
        return employeesList.filter((emp) => {
            if (emp?.isTallySyncMaster) return false
            if (!selectedLeaveState || selectedLeaveState.value === "ALL") {
                return true
            }
            if (selectedLeaveState.value === "UNASSIGNED") {
                return !emp?.state || !emp.state.trim()
            }
            const empState = (emp?.state || "").trim().toLowerCase()
            const targetState = (selectedLeaveState.value || "").trim().toLowerCase()
            return empState === targetState
        })
    }, [employeesList, selectedLeaveState])

    const buildEmployeeUpdatePayload = (emp, newLeaveCount) => {
        let payload = {
            name: emp.name,
            phoneNumber: parseInt(emp.phoneNumber),
            isAdmin: emp.isAdmin,
            designation: emp.designation || "",
            userType: emp.userType || "employee",
            availableLeaves: Math.floor(Number(newLeaveCount)),
            state: emp?.state || "",
            group: emp?.group || "",
            isGeoFenced: emp?.isGeoFenced || false,
            geoFenceRadius: emp?.geoFenceRadius || 0.0,
            geoFenceCenter: emp?.geoFenceCenter || [0.0, 0.0],
        }

        if (emp?.orderCommissionInPercentage !== undefined) {
            payload.orderCommissionInPercentage = emp.orderCommissionInPercentage
        }

        if (emp?.ruleType === "custom") {
            payload.ruleType = "custom"
            payload.tripRules = emp?.tripRules || []
            payload.fixedExpenses = emp?.fixedExpenses || []
            payload.expenseTypes = emp?.expenseTypes || []
            payload.modeOfTransports = emp?.modeOfTransports || []
            payload.dailyAllowanceRules = emp?.dailyAllowanceRules || []
            payload.compensationPerKm = emp?.compensationPerKm || 0.0
        } else {
            payload.ruleType = "default"
            payload.tripRules = []
            payload.fixedExpenses = []
            payload.expenseTypes = []
            payload.modeOfTransports = []
            payload.dailyAllowanceRules = []
            payload.compensationPerKm = 0.0
        }

        return payload
    }

    const handleConfirmResetLeaves = () => {
        const count = Math.floor(Number(leaveResetCount))
        if (isNaN(count) || count < 0) {
            toast.error("Please enter a valid non-negative leave count")
            return
        }

        if (targetedEmployees.length === 0) {
            toast.error("No employees found for the selected state filter")
            return
        }

        const stateLabel = selectedLeaveState?.value === "ALL"
            ? "all states"
            : (selectedLeaveState?.value === "UNASSIGNED" ? "unassigned states" : selectedLeaveState?.value)

        confirmAlert({
            title: "Confirm Leave Reset",
            message: `Are you sure you want to set Available Leaves to ${count} for ${targetedEmployees.length} employee(s) in ${stateLabel}? This will update their current leave balances.`,
            buttons: [
                {
                    label: "Yes, Reset Leaves",
                    onClick: () => executeLeaveReset(count)
                },
                {
                    label: "Cancel",
                    onClick: () => {}
                }
            ]
        })
    }

    const executeLeaveReset = async (newLeaveCount) => {
        setIsResettingLeaves(true)
        setResetProgress({ current: 0, total: targetedEmployees.length })

        let successCount = 0
        let failCount = 0
        const chunkSize = 5

        for (let i = 0; i < targetedEmployees.length; i += chunkSize) {
            const chunk = targetedEmployees.slice(i, i + chunkSize)
            await Promise.all(chunk.map(async (emp) => {
                try {
                    const payload = buildEmployeeUpdatePayload(emp, newLeaveCount)
                    const resp = await axios.put(`${DEV_SERVER}/auth/v2/employee/${emp.id}`, payload, {
                        headers: {
                            Authorization: `Bearer ${userSignal.value?.token}`,
                        },
                    })
                    if (resp?.data?.status) {
                        successCount++
                    } else {
                        failCount++
                    }
                } catch (err) {
                    console.error(`Failed to update leaves for ${emp?.name || emp?.id}`, err)
                    failCount++
                } finally {
                    setResetProgress(prev => ({ ...prev, current: prev.current + 1 }))
                }
            }))
        }

        setIsResettingLeaves(false)

        if (successCount > 0) {
            toast.success(`Successfully updated leaves to ${newLeaveCount} for ${successCount} employee(s)!`)
            await fetchEmployees()
        }
        if (failCount > 0) {
            toast.error(`Failed to update ${failCount} employee(s). Please check network or try again.`)
        }
    }

    const settingTypes = [
        {
            "name": "General Settings",
            "description": "Manage your organisation's info",
            "id": "generalSettings"
        },
        {
            "name": "Trip Configuration",
            "description": "Manage your organisation's trip configuration",
            "id": "tripConfiguration"
        },
        {
            "name": "Order Configuration",
            "description": "Manage your organisation's order configuration",
            "id": "orderConfiguration"
        },
        {
            "name": "Product Configuration",
            "description": "Manage your organisation's product configuration",
            "id": "productConfiguration"
        },
        {
            "name": "Expense Configuration",
            "description": "Manage your organisation's expense types",
            "id": "expenseConfiguration"
        },
        {
            "name": "Holiday & Leave Configuration",
            "description": "Manage your organisation's holiday configuration",
            "id": "holidayAndLeaveConfiguration"
        }
    ]

    if ((isOrderModuleActivated && isTallyIntegrationActivated)) {
        settingTypes.push({
            "name": "Tally Configuration",
            "description": "Manage your organisation's tally configuration",
            "id": "tallyConfiguration"
        })
    }

    return (
        <Fragment>
            <FsLightbox
                toggler={toggler}
                sources={[icon4, shap2, icon8, shap4, icon2, shap6, icon5, shap4, icon1]}
            />
            <Tab.Container defaultActiveKey="first">
                <Row>
                    <Col lg="9" style={{ margin: "0px auto" }}>
                        <Card>
                            <Card.Header className="shadow py-4 d-flex justify-content-between" style={{ backgroundColor: "#fdf0e7" }}>
                                <div className="d-flex align-items-center" style={{ columnGap: '1rem' }}>
                                    <i className="btn fas fa-arrow-left d-flex justify-content-center align-items-center shadow" style={{ width: "40px", height: "50px", borderRadius: "50%", backgroundColor: "white", cursor: "pointer" }} onClick={() => {
                                        // remove the href attribute
                                        let href = window.location.href.split("#")
                                        if (href.length) {
                                            window.location.href = `${window.location.href.split("#")[0]}#main`
                                        }
                                    }}></i>
                                    <h2 className="text-primary">{(activeKey && activeKey !== "main") ? (settingTypes.filter((settingType) => settingType.id === activeKey)?.length > 0 ? settingTypes.filter((settingType) => settingType.id === activeKey)[0]?.name : '') : "Organisation Settings"}</h2>
                                </div>

                                <>
                                    {updateOrgMutation.isLoading ? <Button variant="primary" type="button" disabled>
                                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"></Spinner>
                                        Loading...
                                    </Button> :
                                        <Button onClick={handleSubmit} type="button" variant="btn btn-primary" disabled={imageUploadMutation.isLoading}>{imageUploadMutation.isLoading ? "Uploading..." : "Save"}</Button>
                                    }
                                </>
                            </Card.Header>
                            <Card.Body>
                                {(activeKey === 0 || activeKey === 'main') && <div className="d-flex flex-column" >
                                    {settingTypes.map((settingType, index) => {
                                        return (
                                            <div key={index} className="p-3" style={{ borderBottom: '1px solid #e5e5e5', cursor: "pointer" }} onClick={() => {
                                                let href = window.location.href.split("#")
                                                if (href.length) {
                                                    href = href[0]
                                                } else {
                                                    href = window.location.href
                                                }
                                                window.location.href = `${href}#${settingType.id}`
                                            }}>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div className="d-flex flex-column">
                                                        <h5 className="m-0">{settingType.name}</h5>
                                                        <p className="ms-3 mb-0">{settingType.description}</p>
                                                    </div>
                                                    <i className="fas fa-chevron-right"></i>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>}

                                {activeKey === "generalSettings" && <div className="d-flex flex-column" >
                                    <div className="d-flex align-items-center justify-content-between pb-4">
                                        <div class="icon-box" style={{ margin: "0px auto", width: "200px", height: "200px", borderRadius: "50%" }}>
                                            <div class="overlay">
                                                <button type="button" style={{ position: "relative" }} data-toggle="copy" data-copy-target="#svg-container-47" data-bs-toggle="tooltip" data-bs-placement="top" title="Copy" class="btn btn-btn btn-sm btn-soft-primary" disabled={imageUploadMutation.isLoading}>{imageUploadMutation.isLoading ? "Loading..." : "Change"} <input type="file" id="file" disabled={imageUploadMutation.isLoading} onChange={(e) => handleFileUpload(e)} onClick={(e) => { e.target.value = null }} style={{ position: "absolute", left: "0%", opacity: 0, cursor: "pointer" }} /></button>

                                            </div>
                                            <div id="svg-container-47">
                                                {logo !== "" ?
                                                    <img src={logo} style={{ borderRadius: "50%", margin: "0px auto", position: "relative" }} width={"200px"} height={"200px"} />
                                                    :
                                                    <Avatar name={name} size='200' round style={{ borderRadius: "50% !important", margin: "0px auto", position: "relative", width: "200px !important", height: "200px !important" }} />
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div style={{ display: "flex", margin: "0px 1rem", flexDirection: "column", alignItems: "center", columnGap: "1rem", rowGap: "1rem" }}>
                                        <div style={{ display: "flex", columnGap: "1rem" }}>
                                            <Form.Group className="form-group">
                                                <Form.Label htmlFor="name" className="">Name</Form.Label>
                                                <Form.Control type="text" className="" id="name" aria-describedby="name" placeholder=" " value={name} onChange={(e) => setName(e.target.value)} />
                                            </Form.Group >
                                            <Form.Group className="form-group">
                                                <Form.Label htmlFor="email" className="">Email</Form.Label>
                                                <Form.Control type="text" className="" id="email" aria-describedby="email" placeholder=" " value={email} onChange={(e) => setEmail(e.target.value)} />
                                            </Form.Group >
                                        </div>
                                        <div style={{ display: "flex", columnGap: "1rem" }}>


                                            <Form.Group className="form-group">
                                                <Form.Label htmlFor="website" className="">Website</Form.Label>
                                                <Form.Control type="text" className="" id="website" aria-describedby="website" placeholder=" " value={website} onChange={(e) => setWebsite(e.target.value)} />
                                            </Form.Group >

                                            <Form.Group className="form-group">
                                                <Form.Label htmlFor="gstin" className="">GSTIN</Form.Label>
                                                <Form.Control type="text" className="" id="gstin" aria-describedby="gstin" placeholder=" " value={gstin} onChange={(e) => setGstin(e.target.value)} />
                                            </Form.Group >
                                        </div>
                                        <div className="w-50" style={{ display: "flex", columnGap: "1rem" }}>


                                            <Form.Group className="form-group w-75">
                                                <Form.Label htmlFor="address" className="">Address</Form.Label>
                                                <Form.Control type="text" className="" id="address" aria-describedby="address" placeholder=" " value={address} onChange={(e) => setAddress(e.target.value)} />
                                            </Form.Group >

                                            <Form.Group className="w-75" controlId="formBasicNote">
                                                <Form.Label>Organisation's State</Form.Label>
                                                <Select as="select" className="w-100 m-0"
                                                    value={{ label: state, value: state }}
                                                    onChange={(e) => {
                                                        setState(e?.value);
                                                    }}
                                                    options={stateNames.map((_state) => {
                                                        return (
                                                            { label: _state, value: _state }
                                                        )
                                                    })}
                                                    isSearchable
                                                />
                                            </Form.Group>
                                        </div>
                                    </div>
                                </div>}

                                {activeKey === "tripConfiguration" && <div className="d-flex flex-column" >
                                    <div style={{ display: "flex", margin: "0px 1rem", flexDirection: "column", alignItems: "center", columnGap: "1rem", rowGap: "1rem" }}>
                                        <div className="justify-content-between w-75" style={{ display: "flex", columnGap: "1rem" }}>
                                            <Form.Group className="form-group w-50">
                                                <Form.Label htmlFor="isStartImageRequired" className="">Is Start and End Image Compulsory</Form.Label>
                                                <Form.Select
                                                    className="w-100"
                                                    id="isStartImageRequired"
                                                    aria-describedby="isStartImageRequired"
                                                    placeholder=" "
                                                    value={isStartImageRequired}
                                                    onChange={(e) => setIsStartImageRequired(e.target.value === "true" ? true : false)}
                                                >
                                                    <option value={true}>True</option>
                                                    <option value={false}>False</option>

                                                </Form.Select>
                                            </Form.Group >

                                            <Form.Group className="form-group w-50" style={{ columnGap: "1rem", textWrap: "nowrap" }}>
                                                <Form.Label htmlFor="maxTripsPerDay" className="">Max Trips Per Day:</Form.Label>
                                                <Form.Control type="number" className="" id="maxTripsPerDay" aria-describedby="maxTripsPerDay" placeholder=" " value={maxTripsPerDay} onChange={(e) => setMaxTripsPerDay(parseFloat(e.target.value))} />
                                            </Form.Group >
                                        </div>

                                        {autoTripStartEnabled && <div className="justify-content-between w-75" style={{ display: "flex", columnGap: "1rem" }}>
                                            <>
                                                <div className="col-12" style={{ display: "flex", columnGap: "1rem" }}>
                                                    <Form.Group className="form-group col-4" style={{ columnGap: "1rem", textWrap: "nowrap" }}>
                                                        <Form.Label htmlFor="autoTripStartTime" className="">Auto Trip Start Time:</Form.Label>
                                                        <Form.Control type="time" className="" id="autoTripStartTime" aria-describedby="autoTripStartTime" placeholder=" " value={autoTripStartTime} onChange={(e) => setAutoTripStartTime(e.target.value)} />
                                                    </Form.Group >

                                                    <Form.Group className="form-group col-4" style={{ columnGap: "1rem", textWrap: "nowrap" }}>
                                                        <Form.Label htmlFor="autoTripEndTime" className="">Auto Trip End Time:</Form.Label>
                                                        <Form.Control type="time" className="" id="autoTripEndTime" aria-describedby="autoTripEndTime" placeholder=" " value={autoTripEndTime} onChange={(e) => setAutoTripEndTime(e.target.value)} />
                                                    </Form.Group >

                                                    <div className="col-4" style={{ display: "flex", columnGap: "1rem", flexDirection: "column" }}>
                                                        <Form.Label htmlFor="autoTripStartFor" className="">Auto Trip Start For:</Form.Label>
                                                        <Form.Check type="checkbox" id="autoTripStartForEmployees" label="Employees" checked={autoTripStartForEmployees} onChange={(e) => setAutoTripStartForEmployees(e.target.checked)} />

                                                        <Form.Check type="checkbox" id="autoTripStartForManagers" label="Managers" checked={autoTripStartForManagers} onChange={(e) => setAutoTripStartForManagers(e.target.checked)} />

                                                        <Form.Check type="checkbox" id="autoTripStartForSuperAdmins" label="Super Admins" checked={autoTripStartForSuperAdmins} onChange={(e) => setAutoTripStartForSuperAdmins(e.target.checked)} />
                                                    </div>
                                                </div>
                                            </>
                                        </div>}

                                        <div className="justify-content-between w-75" style={{ display: "flex", columnGap: "1rem" }}>
                                            <Form.Group className="form-group d-flex align-items-center" style={{ columnGap: "1rem", textWrap: "nowrap" }}>
                                                <Form.Label htmlFor="compensationPerKm" className="">Compensation Per Km:</Form.Label>
                                                <Form.Control type="number" className="" id="compensationPerKm" aria-describedby="compensationPerKm" placeholder=" " value={compensationPerKm} onChange={(e) => setCompensationPerKm(parseFloat(e.target.value))} />
                                            </Form.Group >
                                        </div>

                                        <div style={{ display: "flex", flexDirection: "column", width: "75%" }}>
                                            <h4 className="mb-2">Mode Of Transports</h4>
                                            <div className="ms-4">
                                                {modeOfTransports?.length > 0 && modeOfTransports.map((transport, index) => {
                                                    return (
                                                        <div key={index} className='d-flex flex-column mb-2'>
                                                            <div style={{ display: "flex", columnGap: "1rem", alignItems: "center" }}>
                                                                <Form.Group className="form-group">
                                                                    <i>{(index + 1) + "."}</i>
                                                                </Form.Group>
                                                                <Form.Group className="form-group">
                                                                    <Form.Control type="text" className="" id="name" aria-describedby="name" placeholder="Transport Name" value={transport.name} onChange={(e) => {
                                                                        let temp = [...modeOfTransports]
                                                                        temp[index].name = e.target.value
                                                                        setModeOfTransports(temp)
                                                                    }} />
                                                                </Form.Group >
                                                                <Form.Group className="form-group">
                                                                    <Form.Control type="number" className="" id="amount" aria-describedby="amount" placeholder="Amount" value={transport.amount || 0} onChange={(e) => {
                                                                        let temp = [...modeOfTransports]
                                                                        temp[index].amount = parseFloat(e.target.value)
                                                                        setModeOfTransports(temp)
                                                                    }} />
                                                                </Form.Group >
                                                                <Form.Group className="form-group">
                                                                    <i className='fa fa-trash' style={{ cursor: "pointer" }} onClick={() => {
                                                                        let temp = [...modeOfTransports]
                                                                        temp.splice(index, 1)
                                                                        setModeOfTransports(temp)
                                                                    }}></i>
                                                                </Form.Group >
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                                <button className='btn btn-light mt-2' onClick={() => setModeOfTransports([...modeOfTransports, { name: "", amount: parseFloat(0) }])}>Add Transport</button>
                                            </div>
                                        </div>

                                        <div className="mt-2" style={{ display: "flex", flexDirection: "column", width: "75%" }}>
                                            <h4 className="mb-2">Daily Allowance Rules</h4>
                                            <div className="ms-4">
                                                {dailyAllowanceRules?.length > 0 && dailyAllowanceRules.map((rule, index) => {
                                                    return (
                                                        <div key={index} className='d-flex flex-column mb-2'>
                                                            <div style={{ display: "flex", columnGap: "1rem", alignItems: "center" }}>
                                                                <Form.Group className="form-group">
                                                                    <i>{(index + 1) + "."}</i>
                                                                </Form.Group>
                                                                <Form.Group className="form-group">
                                                                    <Form.Control type="text" className="" id="name" aria-describedby="name" placeholder="Rule Name" value={rule.name} onChange={(e) => {
                                                                        let temp = [...dailyAllowanceRules]
                                                                        temp[index].name = e.target.value
                                                                        setDailyAllowanceRules(temp)
                                                                    }} />
                                                                </Form.Group >
                                                                <Form.Group className="form-group">
                                                                    <Form.Control type="number" className="" id="amount" aria-describedby="amount" placeholder="Amount" value={rule.amount || 0} onChange={(e) => {
                                                                        let temp = [...dailyAllowanceRules]
                                                                        temp[index].amount = parseFloat(e.target.value)
                                                                        setDailyAllowanceRules(temp)
                                                                    }} />
                                                                </Form.Group >
                                                                <Form.Group className="form-group">
                                                                    <i className='fa fa-trash' style={{ cursor: "pointer" }} onClick={() => {
                                                                        let temp = [...dailyAllowanceRules]
                                                                        temp.splice(index, 1)
                                                                        setDailyAllowanceRules(temp)
                                                                    }}></i>
                                                                </Form.Group >
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                                <button className='btn btn-light mt-2' onClick={() => setDailyAllowanceRules([...dailyAllowanceRules, { name: "", amount: parseFloat(0) }])}>Add Rule</button>
                                            </div>
                                        </div>

                                        <div className="mt-2" style={{ display: "flex", flexDirection: "column", width: "75%" }}>
                                            <h4 className="mb-2">
                                                Trip Rules
                                            </h4>
                                            <div className="ms-4">
                                                {tripRules?.length > 0 && tripRules.map((rule, index) => {
                                                    return (
                                                        <div key={index} className='d-flex flex-column mb-2'>
                                                            <div style={{ display: "flex", columnGap: "1rem", alignItems: "center" }}>
                                                                <Form.Group className="form-group">
                                                                    <i>{(index + 1) + "."}</i>
                                                                </Form.Group>
                                                                <Form.Group className="form-group">
                                                                    <Form.Control type="text" className="" id="name" aria-describedby="name" placeholder="Rule Name" value={rule.name} onChange={(e) => {
                                                                        let temp = [...tripRules]
                                                                        temp[index].name = e.target.value
                                                                        setTripRules(temp)
                                                                    }} />
                                                                </Form.Group >
                                                                <Form.Group className="form-group">
                                                                    <Form.Control as="select" className="" id="type" aria-describedby="type" placeholder="Rule Type" value={rule.conditionType} onChange={(e) => {
                                                                        let temp = [...tripRules]
                                                                        temp[index].conditionType = e.target.value
                                                                        setTripRules(temp)
                                                                    }
                                                                    }>
                                                                        <option value="any">Any</option>
                                                                        <option value="all">All</option>
                                                                    </Form.Control>
                                                                </Form.Group >
                                                                <Form.Group className="form-group">
                                                                    <Form.Control type="number" className="" id="amount" aria-describedby="amount" placeholder="Amount" value={rule.amount} onChange={(e) => {
                                                                        let temp = [...tripRules]
                                                                        temp[index].amount = parseFloat(e.target.value)
                                                                        setTripRules(temp)
                                                                    }} />
                                                                </Form.Group >
                                                                <Form.Group className="form-group">
                                                                    <i className='fa fa-trash' style={{ cursor: "pointer" }} onClick={() => {
                                                                        let temp = [...tripRules]
                                                                        temp.splice(index, 1)
                                                                        setTripRules(temp)
                                                                    }}></i>
                                                                </Form.Group >
                                                            </div>
                                                            <div className='ms-5'>

                                                                {rule?.conditions?.length > 0 && rule.conditions.map((condition, index2) => {
                                                                    return (
                                                                        <div key={`condition-${index2}`} style={{ display: "flex", columnGap: "1rem", alignItems: "center" }}>
                                                                            <Form.Group className="form-group">
                                                                                <Form.Control as="select" className="" id="field" aria-describedby="field" placeholder="Field" value={condition.field} onChange={(e) => {
                                                                                    let temp = [...tripRules]
                                                                                    temp[index].conditions[index2].field = e.target.value
                                                                                    setTripRules(temp)
                                                                                }}>
                                                                                    <option value="totalDistance">Total Distance</option>
                                                                                    <option value="totalNewCustomers">Total Customers</option>
                                                                                    <option value="totalExpense">Total Expense</option>
                                                                                    <option value="totalTime">Total Time</option>
                                                                                </Form.Control>
                                                                            </Form.Group >
                                                                            <Form.Group className="form-group">
                                                                                <Form.Control as="select" className="" id="operator" aria-describedby="operator" placeholder="Operator" value={condition.operator} onChange={(e) => {
                                                                                    let temp = [...tripRules]
                                                                                    temp[index].conditions[index2].operator = e.target.value
                                                                                    setTripRules(temp)
                                                                                }}>
                                                                                    <option value=">">Greater than</option>
                                                                                    <option value={">="}>Greater than or equal to</option>
                                                                                    <option value="<">Less than</option>
                                                                                    <option value="<=">Less than or equal to</option>
                                                                                    <option value="=">Equal to</option>
                                                                                </Form.Control>
                                                                            </Form.Group >
                                                                            <Form.Group className="form-group">
                                                                                <Form.Control type="number" className="" id="value" aria-describedby="value" placeholder="Value" value={condition.value} onChange={(e) => {
                                                                                    let temp = [...tripRules]
                                                                                    temp[index].conditions[index2].value = parseFloat(e.target.value)
                                                                                    setTripRules(temp)
                                                                                }} />
                                                                            </Form.Group >
                                                                            <Form.Group className="form-group">
                                                                                <i className='fa fa-trash' style={{ cursor: "pointer" }} onClick={() => {
                                                                                    let temp = [...tripRules]
                                                                                    temp[index].conditions.splice(index2, 1)
                                                                                    setTripRules(temp)
                                                                                }}></i>
                                                                            </Form.Group >
                                                                        </div>
                                                                    )
                                                                })}


                                                                <button className='btn btn-light' onClick={() => {
                                                                    let temp = [...tripRules]
                                                                    temp[index]?.conditions?.push({ field: "totalDistance", operator: ">", value: parseFloat(0) })
                                                                    setTripRules(temp)
                                                                }}>Add Condiiton</button>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                                <button className='btn btn-light mt-2' onClick={() => setTripRules([...tripRules, { name: "", conditionType: "any", conditions: [], amount: parseFloat(0) }])}>Add Rule</button>
                                            </div>
                                        </div>
                                        <div className="mt-2" style={{ display: "flex", flexDirection: "column", width: "75%" }}>
                                            <h4 className="mb-2">Fixed Expenses</h4>
                                            <div className="ms-4">
                                                {fixedExpenses?.length > 0 && fixedExpenses.map((expense, index) => {
                                                    return (
                                                        <div key={index} className='d-flex flex-column mb-2'>
                                                            <div style={{ display: "flex", columnGap: "1rem", alignItems: "center" }}>
                                                                <Form.Group className="form-group">
                                                                    <i>{(index + 1) + "."}</i>
                                                                </Form.Group>
                                                                <Form.Group className="form-group">
                                                                    <Form.Control type="text" className="" id="name" aria-describedby="name" placeholder="Rule Name" value={expense.name} onChange={(e) => {
                                                                        let temp = [...fixedExpenses]
                                                                        temp[index].name = e.target.value
                                                                        setFixedExpenses(temp)
                                                                    }} />
                                                                </Form.Group >
                                                                <Form.Group className="form-group">
                                                                    <Form.Control type="number" className="" id="amount" aria-describedby="amount" placeholder="Amount" value={expense.amount} onChange={(e) => {
                                                                        let temp = [...fixedExpenses]
                                                                        temp[index].amount = parseFloat(e.target.value)
                                                                        setFixedExpenses(temp)
                                                                    }} />
                                                                </Form.Group >
                                                                <Form.Group className="form-group">
                                                                    <i className='fa fa-trash' style={{ cursor: "pointer" }} onClick={() => {
                                                                        let temp = [...fixedExpenses]
                                                                        temp.splice(index, 1)
                                                                        setFixedExpenses(temp)
                                                                    }}></i>
                                                                </Form.Group >
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                                <button className='btn btn-light mt-2' onClick={() => setFixedExpenses([...fixedExpenses, { name: "", amount: parseFloat(0), timeDuration: "monthly" }])}>Add Rule</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>}

                                {(isOrderModuleActivated && activeKey === "orderConfiguration") && <div className="d-flex flex-column" >
                                    <h4 className="mb-2">Order Stage Types</h4>
                                    <div className="ms-4">
                                        {orderStageTypes.length > 0 && orderStageTypes.map((orderStageType, index) => {

                                            return (
                                                <div key={index} className='d-flex flex-column mb-2'>
                                                    <div style={{ display: "flex", columnGap: "1rem", alignItems: "center" }}>
                                                        <Form.Group className="form-group">
                                                            <i>{(index + 1) + "."}</i>
                                                        </Form.Group>
                                                        <Form.Group className="form-group">
                                                            <Form.Control type="text" className="" id="name" aria-describedby="name" placeholder="Stage Name" value={orderStageType} onChange={(e) => {
                                                                let temp = [...orderStageTypes]
                                                                temp[index] = e.target.value
                                                                setOrderStageTypes(temp)
                                                            }} />
                                                        </Form.Group >
                                                        <Form.Group className="form-group w-25">
                                                            {/* <Form.Label>Color</Form.Label> */}
                                                            <Select
                                                                // label="Color"
                                                                className='w-100'
                                                                placeholder="Select Color"
                                                                options={colorOptionsForOrderStatuses.map((e) => ({ label: <Badge bg='none' style={{ backgroundColor: colorHexMapping[e] }}>{e}</Badge>, value: colorHexMapping[e] }))}
                                                                value={{ label: <Badge bg='none' style={{ backgroundColor: orderStageColors[orderStageType] }}>{colorHexMappingReverse[orderStageColors[orderStageType]]}</Badge>, value: orderStageColors[orderStageType] }}
                                                                onChange={(e) => {
                                                                    let temp = { ...orderStageColors }
                                                                    temp[orderStageType] = e.value
                                                                    setOrderStageColors(temp)
                                                                }}
                                                            />
                                                        </Form.Group >
                                                        <Form.Group className="form-group">
                                                            <i className='fa fa-trash' style={{ cursor: "pointer" }} onClick={() => {
                                                                let temp = [...orderStageTypes]
                                                                temp.splice(index, 1)
                                                                setOrderStageTypes(temp)
                                                            }}></i>
                                                        </Form.Group >
                                                    </div>
                                                </div>
                                            )
                                        })}
                                        <button className='btn btn-light mt-2' onClick={() => setOrderStageTypes(
                                            [...orderStageTypes, `Stage ${orderStageTypes.length + 1}`]
                                        )}>Add Stage</button>
                                    </div>
                                </div>}

                                {(isOrderModuleActivated && isTallyIntegrationActivated && activeKey === "tallyConfiguration") && <div style={{ display: "flex", flexDirection: "column", width: "75%" }}>
                                    <div className="ms-4">
                                        <div style={{ display: "flex", columnGap: "1rem" }}>
                                            <Form.Group className="form-group">
                                                <Form.Label htmlFor="tallyHostIP" className="">Tally Host IP</Form.Label>
                                                <Form.Control type="text" className="" id="tallyHostIP" aria-describedby="tallyHostIP" placeholder="Eg: 192.168.1.57" value={tallyConfig?.hostIP} onChange={(e) => {
                                                    let temp = { ...tallyConfig }
                                                    temp.hostIP = e.target.value
                                                    setTallyConfig(temp)
                                                }} />
                                            </Form.Group >
                                            <Form.Group className="form-group">
                                                <Form.Label htmlFor="tallyPort" className="">Tally Port</Form.Label>
                                                <Form.Control type="text" className="" id="tallyPort" aria-describedby="tallyPort" placeholder="Eg: 9000" value={tallyConfig?.port} onChange={(e) => {
                                                    let temp = { ...tallyConfig }
                                                    temp.port = e.target.value
                                                    setTallyConfig(temp)
                                                }} />
                                            </Form.Group >
                                            <button className='btn btn-light mt-2 me-auto btn-sm align-self-center' disabled={tallySyncMasterCreateMutation.isLoading} onClick={async () => {

                                                tallySyncMasterCreateMutation.mutate()
                                            }}>
                                                {tallySyncMasterCreateMutation.isLoading ? "Loading..." : "Create Tally Sync Master"}
                                            </button>

                                        </div>
                                        <div>
                                            <Form.Label htmlFor='Companies' className='form-label mt-2'>Companies</Form.Label>

                                            <div className='d-flex flex-column ps-4'>

                                                {(tallyConfig && tallyConfig?.companies && tallyConfig?.companies?.length) && tallyConfig?.companies.map((company, index) => {
                                                    return (
                                                        <div key={index} className='d-flex flex-column mb-2'>
                                                            <div style={{ display: "flex", columnGap: "1rem", alignItems: "center" }}>
                                                                <Form.Group className="form-group align-self-end pb-2">
                                                                    <i className="mb-3">{(index + 1) + "."}</i>
                                                                </Form.Group>
                                                                <Form.Group className="form-group col-8">
                                                                    <Form.Label htmlFor="companyName" className="">Name</Form.Label>
                                                                    <Form.Control type="text" className="" id="companyName" aria-describedby="companyName" placeholder="Company Name" value={company.companyName} onChange={(e) => {
                                                                        let temp = { ...tallyConfig }
                                                                        let tempCompanies = [...temp.companies]
                                                                        tempCompanies[index].companyName = e.target.value
                                                                        temp.companies = tempCompanies
                                                                        setTallyConfig(temp)
                                                                    }} />
                                                                </Form.Group >
                                                                <Form.Group className="form-group">
                                                                    <Form.Label htmlFor="syncFromDate" className="">Sync From</Form.Label>
                                                                    <Form.Control type="date" className="" id="syncFromDate" aria-describedby="syncFromDate" placeholder="Sync From Date" value={company.syncFromDate} onChange={(e) => {
                                                                        let temp = { ...tallyConfig }
                                                                        let tempCompanies = [...temp.companies]
                                                                        tempCompanies[index].syncFromDate = e.target.value
                                                                        tempCompanies[index].lastSyncDate = e.target.value
                                                                        temp.companies = tempCompanies
                                                                        setTallyConfig(temp)
                                                                    }} />
                                                                </Form.Group >
                                                                <Form.Group className="form-group align-self-end">
                                                                    <i className='fa fa-trash mb-3' style={{ cursor: "pointer", width: "30px", transform: "scale(1.2)" }} onClick={() => {
                                                                        let temp = { ...tallyConfig }
                                                                        let tempCompanies = [...temp.companies]
                                                                        tempCompanies.splice(index, 1)
                                                                        temp.companies = tempCompanies
                                                                        setTallyConfig(temp)
                                                                    }}></i>
                                                                </Form.Group >
                                                            </div>
                                                        </div>
                                                    )
                                                })}

                                                <button className='btn btn-light mt-2 me-auto btn-sm' disabled={getCompaniesFromTally.isLoading} onClick={async () => {

                                                    getCompaniesFromTally.mutate({
                                                        host: tallyConfig.hostIP,
                                                        port: tallyConfig.port
                                                    })
                                                }}>
                                                    {getCompaniesFromTally.isLoading ? "Loading..." : "Get Companies"}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>}

                                {(activeKey === "productConfiguration") && <div className="d-flex flex-column" >
                                    <div className="mt-2" style={{ display: "flex", flexDirection: "column", width: "75%" }}>
                                        <h4 className="mb-2">Product Specifications Setup</h4>
                                        <Form.Group className="form-group ms-4" >
                                            <Form.Label htmlFor="categories" className="">Categories</Form.Label>
                                            <ReactChipInput
                                                classes='px-2'
                                                chips={categories}
                                                onSubmit={(chip) => {
                                                    let temp = [...categories]
                                                    temp.push(chip)
                                                    setCategories(temp)
                                                }}
                                                onRemove={(index) => {
                                                    let temp = [...categories]
                                                    temp.splice(index, 1)
                                                    setCategories(temp)
                                                }}
                                            />
                                        </Form.Group >
                                        <Form.Group className="form-group ms-4" >
                                            <Form.Label htmlFor="packagingTypes" className="">Packaging Types</Form.Label>
                                            <ReactChipInput
                                                chips={packagingTypes}
                                                classes="px-2"
                                                onSubmit={(chip) => {
                                                    let temp = [...packagingTypes]
                                                    temp.push(chip)
                                                    setPackagingTypes(temp)
                                                }}
                                                onRemove={(index) => {
                                                    let temp = [...packagingTypes]
                                                    temp.splice(index, 1)
                                                    setPackagingTypes(temp)
                                                }}
                                            />
                                        </Form.Group >
                                    </div>
                                </div>}

                                {(activeKey === "expenseConfiguration") && <div className="d-flex flex-column" >
                                    <div className="mt-2" style={{ display: "flex", flexDirection: "column", width: "75%" }}>
                                        <h4 className="mb-2">Expense Types</h4>
                                        {expenseTypes?.length > 0 && expenseTypes.map((expenseType, index) => {
                                            return (
                                                <div className="ms-4" style={{ display: "flex", columnGap: "1rem" }}>
                                                    <div style={{ display: "flex", columnGap: "1rem", alignItems: "center" }}>
                                                    <Form.Group className="form-group">
                                                                    <i>{(index + 1) + "."}</i>
                                                                </Form.Group>
                                                    <Form.Group className="form-group">
                                                        <Form.Label htmlFor="expenseType">Expense Type</Form.Label>
                                                        <Form.Control type="text" id="expenseType" placeholder="Enter Expense Type" value={expenseType.name} onChange={(e) => {
                                                            let temp = [...expenseTypes]
                                                            temp[index].name = e.target.value
                                                            setExpenseTypes(temp)
                                                        }} />
                                                    </Form.Group >
                                                    </div>
                                                </div>
                                            )
                                        })}
                                        <button className='btn btn-light mt-2 me-auto btn-sm' onClick={() => {
                                            let temp = [...expenseTypes]
                                            temp.push({ name: "" })
                                            setExpenseTypes(temp)
                                        }}
                                        >
                                            Add Expense Type
                                        </button>
                                    </div>
                                </div>}

                                {(activeKey === "holidayAndLeaveConfiguration") && <div className="d-flex flex-column" style={{ width: "100%", maxWidth: "880px" }}>
                                    <div className="mt-2" style={{ display: "flex", flexDirection: "column" }}>
                                        <h4 className="mb-2">Setup Holidays</h4>
                                        <div className="ms-4" style={{ display: "flex", columnGap: "1rem" }}>
                                            <Form.Group className="form-group">
                                                <Form.Check
                                                    type="checkbox"
                                                    label="Saturday Working Day"
                                                    checked={isSaturdayWorking}
                                                    onChange={(e) => setIsSaturdayWorking(e.target.checked)}
                                                />
                                            </Form.Group >

                                            <Form.Group className="form-group">
                                                <Form.Check
                                                    type="checkbox"
                                                    label="Sunday Working Day"
                                                    checked={isSundayWorking}
                                                    onChange={(e) => setIsSundayWorking(e.target.checked)}
                                                />
                                            </Form.Group >
                                        </div>

                                        <div className="ms-4" style={{ display: "flex", columnGap: "1rem" }}>
                                            <Form.Group className="form-group">
                                                <Form.Label htmlFor="holidays" className=""><h6>Select CSV files with holidays - (<Link target='_blank' to={"https://docs.google.com/spreadsheets/d/11JKgIHvktjrCNMQepJvFi_XTAemmacoYBQtoAOn9eGA/edit?usp=sharing"}>Check Example</Link>)</h6></Form.Label>

                                                <div className='d-flex align-items-center' style={{ columnGap: "1rem" }}>
                                                    {fileLoadingStatus !== null && <>
                                                        {!fileLoadingStatus ? <i className="fas fa-check-circle" style={{ color: "lightgreen" }}></i>
                                                            :
                                                            <div className="spinner-border text-primary" role="status">
                                                                <span className="visually-hidden">Loading...</span>
                                                            </div>}
                                                    </>
                                                    }
                                                    <CSVReader
                                                        cssClass="react-csv-input"
                                                        onFileLoaded={handleForce}
                                                        parserOptions={papaparseOptions}
                                                        inputStyle={{ margin: "0px" }}
                                                    />
                                                </div>
                                            </Form.Group >
                                        </div>
                                    </div>

                                    <hr className="my-4" />

                                    <div className="mt-1" style={{ display: "flex", flexDirection: "column" }}>
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <div>
                                                <h4 className="mb-1">Leave Allocation & Reset</h4>
                                                <p className="text-muted mb-0" style={{ fontSize: "0.875rem" }}>
                                                    Allocate or reset available leaves for all employees or filtered state-wise.
                                                </p>
                                            </div>
                                            <Button 
                                                variant="outline-secondary" 
                                                size="sm" 
                                                onClick={fetchEmployees} 
                                                disabled={loadingEmployees || isResettingLeaves}
                                            >
                                                <i className={`fas fa-sync-alt me-1 ${loadingEmployees ? 'fa-spin' : ''}`}></i> Refresh Employees
                                            </Button>
                                        </div>

                                        {loadingEmployees && employeesList.length === 0 ? (
                                            <div className="d-flex align-items-center p-3 text-muted">
                                                <Spinner animation="border" size="sm" className="me-2" />
                                                Loading employees list...
                                            </div>
                                        ) : (
                                            <div className="card p-3 shadow-none border" style={{ backgroundColor: "#f8f9fa", borderRadius: "10px" }}>
                                                <Row className="g-3 align-items-end">
                                                    <Col md={3} sm={12}>
                                                        <Form.Group controlId="leaveAllocationCount">
                                                            <Form.Label className="fw-bold">Leaves Count</Form.Label>
                                                            <Form.Control
                                                                type="number"
                                                                min="0"
                                                                placeholder="e.g. 20"
                                                                value={leaveResetCount}
                                                                onChange={(e) => setLeaveResetCount(e.target.value)}
                                                                disabled={isResettingLeaves}
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                    <Col md={5} sm={12}>
                                                        <Form.Group controlId="leaveAllocationStateFilter">
                                                            <Form.Label className="fw-bold">Target State</Form.Label>
                                                            <Select
                                                                options={leaveStateOptions}
                                                                value={selectedLeaveState}
                                                                onChange={(selected) => setSelectedLeaveState(selected)}
                                                                isSearchable
                                                                isDisabled={isResettingLeaves}
                                                                placeholder="Select State or All States"
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                    <Col md={4} sm={12}>
                                                        <Button
                                                            variant="primary"
                                                            className="w-100"
                                                            onClick={handleConfirmResetLeaves}
                                                            disabled={
                                                                isResettingLeaves || 
                                                                loadingEmployees || 
                                                                targetedEmployees.length === 0 || 
                                                                leaveResetCount === "" || 
                                                                isNaN(Number(leaveResetCount)) || 
                                                                Number(leaveResetCount) < 0
                                                            }
                                                        >
                                                            {isResettingLeaves ? (
                                                                <>
                                                                    <Spinner as="span" animation="border" size="sm" className="me-1" />
                                                                    Updating ({resetProgress.current}/{resetProgress.total})...
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <i className="fas fa-redo-alt me-1"></i> Reset Leaves ({targetedEmployees.length})
                                                                </>
                                                            )}
                                                        </Button>
                                                    </Col>
                                                </Row>

                                                {/* Target summary banner */}
                                                <div className="mt-3 p-3 rounded d-flex flex-wrap justify-content-between align-items-center" style={{ backgroundColor: "#e9ecef" }}>
                                                    <div>
                                                        <span className="fw-bold text-dark">Target Employees: </span>
                                                        <Badge bg={targetedEmployees.length > 0 ? "primary" : "secondary"} className="me-2 fs-6">
                                                            {targetedEmployees.length} {targetedEmployees.length === 1 ? "Employee" : "Employees"}
                                                        </Badge>
                                                        <span className="text-muted" style={{ fontSize: "0.85rem" }}>
                                                            in {selectedLeaveState?.value === "ALL" ? "All States" : (selectedLeaveState?.value === "UNASSIGNED" ? "Unassigned State" : (selectedLeaveState?.value || "Selected State"))}
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span className="text-muted" style={{ fontSize: "0.85rem" }}>
                                                            Each will be allocated: <strong className="text-primary">{leaveResetCount || 0}</strong> available leaves
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* Progress Bar when updating */}
                                                {isResettingLeaves && (
                                                    <div className="mt-3">
                                                        <div className="d-flex justify-content-between text-muted mb-1" style={{ fontSize: "0.85rem" }}>
                                                            <span>Updating leave balances...</span>
                                                            <span>{resetProgress.current} / {resetProgress.total}</span>
                                                        </div>
                                                        <ProgressBar 
                                                            animated 
                                                            now={resetProgress.total > 0 ? Math.round((resetProgress.current / resetProgress.total) * 100) : 0} 
                                                            label={`${resetProgress.total > 0 ? Math.round((resetProgress.current / resetProgress.total) * 100) : 0}%`}
                                                        />
                                                    </div>
                                                )}

                                                {/* Target Employees Preview */}
                                                {targetedEmployees.length > 0 && !isResettingLeaves && (
                                                    <div className="mt-3">
                                                        <small className="text-muted d-block mb-1">
                                                            Preview of employees who will be updated:
                                                        </small>
                                                        <div className="d-flex flex-wrap" style={{ maxHeight: "120px", overflowY: "auto", gap: "0.35rem" }}>
                                                            {targetedEmployees.map((emp) => (
                                                                <span 
                                                                    key={emp.id} 
                                                                    className="badge bg-light text-dark border p-2"
                                                                    title={`Current Available Leaves: ${emp?.availableLeaves ?? 0} | State: ${emp?.state || 'N/A'}`}
                                                                >
                                                                    {emp.name || emp.phoneNumber} 
                                                                    <span className="text-secondary ms-1" style={{ fontSize: "0.75rem" }}>
                                                                        ({emp?.state || 'No State'} &bull; Leaves: {emp?.availableLeaves ?? 0})
                                                                    </span>
                                                                </span>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Tab.Container>
        </Fragment>
    )
}